export const ACCOUNT_TYPE_PERSONAL = 'personal';
export const ACCOUNT_TYPE_TEAM = 'team';
export const ACCOUNT_TYPE_ENTERPRISE = 'enterprise';
export const ALL_ACCOUNT_TYPES = [
  ACCOUNT_TYPE_PERSONAL,
  ACCOUNT_TYPE_TEAM,
  ACCOUNT_TYPE_ENTERPRISE,
];
export const TEAM_ACCOUNT_TYPES = [ACCOUNT_TYPE_TEAM, ACCOUNT_TYPE_ENTERPRISE];
